import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';

// Key used in route data to opt a route into preloading.
// Example: { path: 'some-path', loadComponent: ..., data: { preload: true } }
export const PRELOAD_ROUTE_DATA_KEY = 'preload';

interface NetworkInformation {
  saveData?: boolean;
  effectiveType?: string;
}

// Preloads only routes explicitly opted in via PRELOAD_ROUTE_DATA_KEY,
// instead of PreloadAllModules downloading every lazy chunk in the app
// right after bootstrap. See todos/optimization.md item 8.
@Injectable({ providedIn: 'root' })
export class SelectivePreloadingStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
    if (route.data?.[PRELOAD_ROUTE_DATA_KEY] !== true) {
      return of(null);
    }
    if (this.isSlowConnection()) {
      return of(null);
    }
    return load();
  }

  private isSlowConnection(): boolean {
    const connection = (
      navigator as unknown as { connection?: NetworkInformation }
    ).connection;
    if (!connection) {
      return false;
    }
    if (connection.saveData) {
      return true;
    }
    return (
      connection.effectiveType === 'slow-2g' ||
      connection.effectiveType === '2g'
    );
  }
}
